import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const settingsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCryptoTop: builder.query({
      query: (payload = {}) => {
        const { topAmountType = 'e' } = payload
        const { page = 1, limitNumber = 50, params = { topAmountType } } = payload
        return {
          url: `/bouser/admin/criptostop/${page}/params`,
          params: { limitNumber, ...removeEmptyKeys(params) },
        }
      },
      transformResponse: (response, meta, args) => {
        return {
          rows: response.amouts,
          count: response.count,
          pages: response.pages,
        }
      },
      providesTags: ['cryptoTop'],
    }),
    setCryptoTop: builder.mutation({
      /**
       * Update of user data from a different user with an authorized role
       * @param {object} - user data
       * @returns
       */
      query: ({ cycle, amount, topAmountType }) => {
        return {
          url: '/bouser/admin/criptostop',
          method: 'POST',
          body: { cycle: cycle, amount: amount, topAmountType: topAmountType },
        }
      },
      invalidatesTags: ['cryptoTop'],
    }),
    getPublicityBanners: builder.query({
      query: (payload = {}) => {
        const { page = 1, limitNumber = 50 } = payload
        return {
          url: `/bouser/admin/publicities/${page}`,
          params: { limitNumber },
        }
      },
      providesTags: ['publicityBanners'],
    }),
    addPublicityBanner: builder.mutation({
      query: ({ file }) => {
        const formData = new FormData()
        formData.append('file', file)
        return {
          url: '/bouser/admin/publicity',
          method: 'POST',
          body: formData,
        }
      },
      invalidatesTags: ['publicityBanners'],
    }),
    setActivePublicityBanner: builder.mutation({
      query: ({ id }) => {
        return {
          url: `/bouser/admin/publicity/setactive/${id}`,
          method: 'PUT',
        }
      },
      invalidatesTags: ['publicityBanners'],
    }),
  }),
  overrideExisting: true,
})

export const {
  useGetCryptoTopQuery,
  useSetCryptoTopMutation,
  useGetPublicityBannersQuery,
  useAddPublicityBannerMutation,
  useSetActivePublicityBannerMutation,
} = settingsApiSlice
